import React, { useEffect } from 'react';
import { Table } from 'react-bootstrap';
import RelatorioService from 'services/relatorio-service';
import RepresentadaService from 'services/representada-service';
import PedidoService from 'services/pedido-service';
import Layout from 'components/layout/base';
import PageTitleCard from 'components/page-title-card';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWeightHanging, faFilter, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import lib from '../../../helpers/lib';
import Skeleton from 'react-loading-skeleton';
import '../styles.scss';

export default function FaturamentoVolume() {
  const mesInicialFiltro = new Date(),
    y = mesInicialFiltro.getFullYear(),
    m = mesInicialFiltro.getMonth();

  const [isLoading, setIsLoading] = React.useState(true);

  const [representadas, setRepresentadas] = React.useState([]);
  const [vendedores, setVendedores] = React.useState([]);
  const [categorias, setCategorias] = React.useState([]);
  const [totalCategorias, setTotalCategorias] = React.useState([]);

  const [filter, setFilter] = React.useState({
    codigoPedido: '',
    representadaId: null,
    vendedorId: null,
    mes: m + 1,
    ano: y
  });

  const [loadedRepresentadas, setLoadedRepresentadas] = React.useState(false);
  const [loadedVendedores, setLoadedVendedores] = React.useState(false);

  useEffect(() => {
    (async () => {
      await getSelectListVendedor();
      getRepresentadas();
    })();
  }, []);

  useEffect(() => {
    if (loadedRepresentadas && loadedVendedores) {
      getFaturamentoVolume();
    }
  }, [loadedRepresentadas, loadedVendedores]);

  useEffect(() => {
    (async () => {
      if (categorias.length > 0) {
        let catTotal = {
          nomeCategoria: ' ',
          volumeFaturadoMesAnterior: +categorias
            .reduce((acc, item) => acc + item.volumeFaturadoMesAnterior, 0)
            .toFixed(2),
          volumePedido: +categorias.reduce((acc, item) => acc + item.volumePedido, 0).toFixed(2),
          volumeFaturado: +categorias
            .reduce((acc, item) => acc + item.volumeFaturado, 0)
            .toFixed(2),
          volumeMeta: +categorias.reduce((acc, item) => acc + item.volumeMeta, 0).toFixed(2)
        };

        catTotal.porcentagemVolumePedido =
          catTotal.volumeMeta != 0
            ? +((catTotal.volumePedido / catTotal.volumeMeta) * 100).toFixed(2)
            : 0;
        catTotal.porcentagemVolumeFaturado =
          catTotal.volumeMeta != 0
            ? +((catTotal.volumeFaturado / catTotal.volumeMeta) * 100).toFixed(2)
            : 0;

        setTotalCategorias([catTotal]);
      }
    })();
  }, [categorias]);

  async function getRepresentadas() {
    const response = await RepresentadaService.selectListAsync();
    if (response?.data) {
      setRepresentadas(response?.data?.data[0]?.options);

      setFilter((prevFilter) => ({
        ...prevFilter,
        representadaId: response?.data?.data[0]?.options[0]?.value
      }));
    }
    setLoadedRepresentadas(true);
  }

  async function getSelectListVendedor() {
    let vendedores = await PedidoService.getSelectListVendedor();
    if (vendedores.data) {
      setVendedores(vendedores.data.data);

      if (vendedores.data.data.length == 1) {
        setFilter((prevFilter) => ({ ...prevFilter, vendedorId: vendedores.data.data[0].value }));
      }
    }
    setLoadedVendedores(true);
  }

  async function getFaturamentoVolume() {
    setIsLoading(true);

    let resultStatus = await RelatorioService.getFaturamentoVolume(filter);

    if (resultStatus.data) {
      setCategorias(resultStatus.data);
    }

    setIsLoading(false);
  }

  async function getExtratoFaturamentoVolume() {
    setIsLoading(true);

    let response = await RelatorioService.getExtratoFaturamentoVolume(filter);

    if (response?.data) {
      let fileName = `faturamento_volume_${lib.getCurrentDateFilename()}.xlsx`;
      lib.downloadFile(response.data.data, fileName);
    }

    setIsLoading(false);
  }

  return (
    <Layout>
      <PageTitleCard title="Volume" icon={<FontAwesomeIcon icon={faWeightHanging} />} />

      <div className="background-relatorio">
        <div className="row filter-bar2 mb-5">
          <div className="col-lg-2">
            <label>Representada</label>
            <Select
              isClearable={false}
              // clearValue={() => {
              //   setFilter({ ...filter, representadaId: null });
              // }}
              styles={customControlStyles}
              placeholder="Selecione..."
              options={representadas}
              value={representadas?.find((x) => x.value === filter.representadaId)}
              onChange={(selectedValue) => {
                setFilter({ ...filter, representadaId: selectedValue?.value });
              }}
            />
          </div>

          <div className="col-lg-2">
            <label>Vendedor</label>
            <Select
              isClearable={vendedores && vendedores?.length > 1}
              clearValue={() => {
                setFilter({ ...filter, vendedorId: null });
              }}
              styles={customControlStyles}
              placeholder="Selecione..."
              options={vendedores}
              value={vendedores?.find((x) => x.value === filter.vendedorId)}
              onChange={(selectedValue) => {
                setFilter({ ...filter, vendedorId: selectedValue?.value });
              }}
            />
          </div>

          <div className="col-lg-2">
            <label>Mês</label>
            <Select
              className="select-form-control"
              value={lib.selectListMeses?.find((item) => item.value === filter.mes)}
              options={lib.selectListMeses}
              isClearable={false}
              onChange={(item) => {
                setFilter({ ...filter, mes: item.value });
              }}
            />
          </div>

          <div className="col-lg-2">
            <label>Ano</label>
            <Select
              className="select-form-control"
              value={lib.selectListAnos?.find((item) => item.value === filter.ano)}
              options={lib.selectListAnos}
              isClearable={false}
              onChange={(item) => {
                setFilter({ ...filter, ano: item.value });
              }}
            />
          </div>

          <div className="col row">
            <div className="col-6"></div>

            <div className="col-3 align-content-end">
              {/* Botão Exportar --------------------------------------------------------------------- */}
              <button
                type="button"
                className="btn btn-secondary btn-sm btn-action"
                onClick={() => {
                  setFilter({
                    ...filter
                  });
                  getExtratoFaturamentoVolume();
                }}
                disabled={isLoading}
              >
                <FontAwesomeIcon icon={faFileExcel} /> Exportar
              </button>
            </div>

            <div className="col-3 align-content-end">
              {/* Botão Filtrar --------------------------------------------------------------------- */}
              <button
                type="button"
                className="btn btn-secondary btn-sm btn-action"
                onClick={() => {
                  setFilter({
                    ...filter
                    //pageNumber: 1
                  });
                  getFaturamentoVolume();
                }}
                disabled={isLoading}
              >
                <FontAwesomeIcon icon={faFilter} /> Filtrar
              </button>
            </div>
          </div>
        </div>

        {/* Lista Representadas ----------------------------------------------------------------- */}
        <div
          className="table-responsive table-historico mt-4"
          onCopy={(e) => lib.parseCopiedText(e)}
        >
          {!isLoading && categorias ? (
            <Table striped bordered hover width="100%" className="table-relatorio">
              <thead>
                <tr>
                  <th>Categoria</th>
                  <th>Fat Mês Anterior</th>
                  <th>Pedido</th>
                  {/* <th>Valor em Cateira (%)</th> */}
                  <th>Faturado</th>
                  {/* <th>Faturado + Carteira</th> */}
                  <th>Objetivo</th>
                  <th style={{ textAlign: 'center' }}>% Pedido</th>
                  <th style={{ textAlign: 'center' }}>% Faturado</th>
                  {/* <th>% Faturado + Carteira</th> */}
                </tr>
              </thead>
              <tbody>
                {categorias.length > 0 ? (
                  ([...categorias, ...totalCategorias] || [])?.map((item, index) => (
                    <tr key={index} className={index >= categorias.length ? 'fw-700' : ''}>
                      <td>{item.nomeCategoria}</td>
                      <td>
                        <span>
                          {/* {item.volumeFaturadoMesAnterior.toString().replace('.', ',')} Kg */}
                          {lib.formatToNumeric(item.volumeFaturadoMesAnterior, 3, true)} Kg
                        </span>
                        {/* <span> ({item.porcentagemVolumeFaturadoMesAnterior}%)</span> */}
                      </td>
                      {/* <td>{item.volumePedido.toString().replace('.', ',')} Kg</td> */}
                      <td>{lib.formatToNumeric(item.volumePedido, 3, true)} Kg</td>
                      {/* <td>
                    {item.volumeCarteira} Kg
                    <span> ({item.porcentagemVolumeCarteira}%)</span>
                  </td> */}
                      {/* <td>{item.volumeFaturado.toString().replace('.', ',')} Kg</td> */}
                      <td>{lib.formatToNumeric(item.volumeFaturado, 3, true)} Kg</td>
                      {/* <td>
                    {item.volumeFaturadoECarteira} Kg
                  </td> */}
                      {/* <td>{item.volumeMeta.toString().replace('.', ',')} Kg</td> */}
                      <td>{lib.formatToNumeric(item.volumeMeta, 3, true)} Kg</td>
                      <td style={{ textAlign: 'center' }}>
                        {/* {item.porcentagemVolumePedido.toString().replace('.', ',')}% */}
                        {lib.formatToNumeric(item.porcentagemVolumePedido, 2, true)}%
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {/* {item.porcentagemVolumeFaturado.toString().replace('.', ',')}% */}
                        {lib.formatToNumeric(item.porcentagemVolumeFaturado, 2, true)}%
                      </td>
                      {/* <td>{item.porcentagemFaturadoECarteira}%</td> */}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={7}>Nenhum registro encontrado.</td>
                  </tr>
                )}
              </tbody>
            </Table>
          ) : (
            <Skeleton count={10} />
          )}
        </div>
      </div>
    </Layout>
  );
}
